import { all, put, call, takeLatest } from "redux-saga/effects";
import { fetchHomeLoanRates } from "network/services/rates";
import type { ISaga } from "../types";
import {
  fetchHomeLoanRatesFailed,
  fetchHomeLoanRatesSuccess,
} from "../actionCreators";

function* processHomeLoanRates(): ISaga {
  try {
    const { data } = yield call(fetchHomeLoanRates);

    yield put(fetchHomeLoanRatesSuccess(data));
  } catch (e) {
    console.log("ERROR FETCHING HOME LOAN RATES", e);
    yield put(fetchHomeLoanRatesFailed());
  }
}

export default function* watcher() {
  yield takeLatest("REQUEST_HOME_LOAN_RATES_DATA", processHomeLoanRates);
}
